import { FaAnglesDown } from "react-icons/fa6";

interface HeroNewProps {
  city?: string; // Opcjonalny parametr city
}

function HeroNew({ city }: HeroNewProps) {
  const displayCity = city || "Twoim mieście"; // Domyślna wartość, jeśli city nie jest podane

  return (
    <section className="relative overflow-x-hidden flex flex-row items-center justify-between lg:h-screen p-6 lg:p-24">
      <img
        className="absolute w-full h-full object-cover z-10 top-0 left-0"
        src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/landscape-specialist-finishing-newly-developed-gar-2023-11-27-05-34-39-utc-Duzy.jpeg"
        alt="Usługi ogrodnicze Drzewus - niwelacja terenu, wycinka drzew, zakładanie ogrodów"
      />
      <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr-hero"></div>
      <div className="w-full h-full flex flex-col items-start justify-center gap-2 lg:gap-6 z-30">
        <h1 className="text-white text-4xl lg:text-7xl text-left">
          Przygotowanie działek pod budowę i zakładanie ogrodów {city ? `${displayCity}` : ""}
        </h1>
        <h2 className="text-white text-2xl lg:text-4xl text-left">
          Oczyszczanie, mulczowanie i prace ziemne {city ? `${displayCity}` : ""}
        </h2>
        <p className="text-white opacity-90 text-left mb-2 text-lg lg:text-xl max-w-[900px]">
          DRZEWUS specjalizuje się w przygotowaniu działek pod budowę oraz kompleksowym zakładaniu ogrodów na terenie miasta {displayCity} i okolic. Wykonujemy oczyszczanie działek, mulczowanie terenu, karczowanie, niwelację terenu oraz zakładanie trawników.
        </p>
        <div className="flex flex-col items-start justify-start lg:flex-row lg:items-center lg:justify-start gap-2">
          <a href="/#uslugi">
            <button className="button-yellow">Poznaj nasze usługi</button>
          </a>
        </div>
        <FaAnglesDown className="hidden lg:block absolute z-50 bottom-12 left-24 animate-bounce text-white text-4xl" />
      </div>
    </section>
  );
}

export default HeroNew;
